<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="16">
        <a-form layout="vertical">
          <a-form-item label="昵称"
            ><a-input v-model="paramData.nickName" placeholder="给自己起个名字"
          /></a-form-item>
          <a-form-model-item label="性别">
            <a-radio-group v-model="paramData.sex">
              <a-radio value="男">男</a-radio>
              <a-radio value="女">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-item label="个性签名"
            ><a-input
              v-model="paramData.signature"
              type="textarea"
              placeholder="个性签名"
          /></a-form-item>
          <a-form-item
            ><a-button type="primary" @click="save">保存</a-button></a-form-item
          >
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "BaseSetting",
  data() {
    return {
      userInfo: {},
      paramData: {
        nickName: "",
        signature: "",
        sex: "",
        userNo: ""
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.paramData.nickName = this.userInfo.nickName;
    this.paramData.signature = this.userInfo.signature;
    this.paramData.sex = this.userInfo.sex;
    this.paramData.userNo = this.userInfo.userNo;
  },
  methods: {
    ...mapActions(["SetUserInfo"]),
    save() {
      this.$http.roomBksApi.changeUserInfo(this.paramData).then(res => {
        if (res.result == 0) {
          this.$message.success(res.msg);
          this.userInfo.nickName = this.paramData.nickName;
          this.userInfo.userName = this.paramData.nickName;
          this.userInfo.sex = this.paramData.sex;
          this.userInfo.signature = this.paramData.signature;
          this.SetUserInfo(this.userInfo);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
